import { useState, useRef, useEffect } from 'react';
import FJAIToolsTab from './view/FJAIToolsTab/FJAIToolsTab';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJAiToolsCategory from './view/FJAiToolsCategory';
import Styles from './FJCommunityAITools.module.less';
import _ from 'lodash';
import PopIcon from '../../../../assets/svg/community/popular.svg?react';
import ImageIcon from '../../../../assets/svg/community/image.svg?react';
import VideoIcon from '../../../../assets/svg/community/video.svg?react';
import AudioIcon from '../../../../assets/svg/community/audio.svg?react';
import PropTypes from 'prop-types';
import FJActivePanel from '../../FJCommonComponent/FJActivePanel/FJActivePanel';
const MARGIN_TOP = 168;
const CATEGORY_LIST = ['popular', 'image', 'video', 'audio'];
const CATEGORY_ICON_MAP = {
    popular: <PopIcon className={Styles.tab_icon} />,
    image: <ImageIcon className={Styles.tab_icon} />,
    video: <VideoIcon className={Styles.tab_icon} />,
    audio: <AudioIcon className={Styles.tab_icon} />,
};

const FJAIToolsContainer = props => {
    const { active, data } = props;
    const _scroller = useRef();
    const _categoryRef = useRef({});
    // 组件更新后会执行的事件
    const _useEffectEvent = useRef('');
    const _autoSelectFunc = useRef();

    const [selectedCategory, setSelectedCategory] = useState('popular');
    const selectedIndex = selectedCategory ? CATEGORY_LIST.indexOf(selectedCategory) : 0;

    const _onChange = index => {
        const clickCategory = CATEGORY_LIST[index];
        if (clickCategory === selectedCategory) return;
        _useEffectEvent.current = 'auto fix scroller';
        setSelectedCategory(clickCategory);
    };

    const _onWheel = () => {
        _useEffectEvent.current = 'auto select category';
    };

    const _onScrollFrame = () => {
        if (!_autoSelectFunc.current && _scroller.current) {
            _autoSelectFunc.current = _.debounce(() => {
                const { scrollTop } = _scroller.current.getScroller();
                for (let i = CATEGORY_LIST.length - 1; i >= 0; i--) {
                    const category = CATEGORY_LIST[i];
                    const div = _categoryRef.current[category];
                    const divTop = div.offsetTop - MARGIN_TOP;
                    if (divTop < scrollTop + 50) {
                        setSelectedCategory(category);
                        break;
                    }
                }
                _useEffectEvent.current = '';
            }, 200);
        }
        if (_useEffectEvent.current === 'auto select category') {
            _autoSelectFunc.current(data);
        }
    };

    useEffect(() => {
        if (_useEffectEvent.current === 'auto fix scroller') {
            const top = _categoryRef.current[selectedCategory].offsetTop;
            _scroller.current.scrollTop(top - MARGIN_TOP, 'smooth');
        }
        _useEffectEvent.current = '';
    });

    const _items = () => {
        return data.map(item => {
            const { category, list, isHot } = item;
            return (
                <FJAiToolsCategory
                    key={category}
                    categoryName={category}
                    list={list}
                    isHot={isHot}
                    ref={e => {
                        _categoryRef.current[category] = e;
                    }}
                />
            );
        });
    };

    return (
        <FJActivePanel active={active} className={Styles.ai_tools_container}>
            <FJAIToolsTab
                tabList={CATEGORY_LIST}
                iconMap={CATEGORY_ICON_MAP}
                currentIndex={selectedIndex}
                title={FJLocalStore._('ai-tools')}
                onChange={_onChange}
            />
            <FJVerticalScroller
                className={Styles.scrollerBox}
                onWheel={_onWheel}
                ref={_scroller}
                onMouseWheel={_onScrollFrame}
            >
                {_items()}
            </FJVerticalScroller>
        </FJActivePanel>
    );
};

FJAIToolsContainer.propTypes = {
    active: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
};

export default FJAIToolsContainer;
